// Phone numbers in international format without spaces or special characters
const WHATSAPP_NUMBER = '919324471736'; // 91 (India) + 93244 71736 (WhatsApp number)
const PHONE_NUMBER = '919324471736'; // 91 (India) + 93244 71736 (phone number)
const DISPLAY_WHATSAPP = '+91 93244 71736'; // Formatted for display
const DISPLAY_PHONE = '+91 93244 71736'; // Formatted for display

/**
 * Generates a WhatsApp URL with the given message
 * @param message - The message to pre-fill in the chat
 * @returns Formatted WhatsApp URL
 */
export const getWhatsAppUrl = (message: string = ''): string => {
  const defaultMessage = 'Hello! I would like to know more about your services.';
  const encodedMessage = encodeURIComponent(message || defaultMessage);
  // WhatsApp API format: https://wa.me/PHONENUMBER?text=URL_ENCODED_MESSAGE
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodedMessage}`;
};

/**
 * Opens WhatsApp chat in a new tab/window
 * @param message - Optional pre-filled message
 */
export const openWhatsApp = (message: string = ''): void => {
  window.open(getWhatsAppUrl(message), '_blank');
};

/**
 * Returns the phone number in international format (no spaces)
 */
export const getPhoneNumber = (): string => PHONE_NUMBER;

/**
 * Returns the phone number in a user-friendly display format
 */
export const getDisplayPhone = (): string => DISPLAY_PHONE;

/**
 * Returns the WhatsApp number in a user-friendly display format
 */
export const getDisplayWhatsApp = (): string => DISPLAY_WHATSAPP;

/**
 * Returns a tel: link for phone calls
 */
export const getCallUrl = (): string => `tel:${PHONE_NUMBER}`;
